import React, { useState, useEffect } from 'react';
import { Button, Spin, message } from 'antd';
import { useSelector } from 'react-redux';
import { SelectEmployee } from '../SelectInput';
import { getRequest } from '../../utils/APICall';
import moment from 'moment';
import LeaveTable from './LeaveTable';
import DatePickerComponent from '../DatePicker';


const LeaveSummary = () => {
  const [employeeId, setEmployeeId] = useState(null);
  const [loading, setLoading] = useState(false);
  const [fromDate, setFromDate] = useState(null);
  const [toDate, setToDate] = useState(null);
  const [leaveData, setLeaveData] = useState([]);
  const { allEmployee } = useSelector((state) => state.employees);
  // console.log("allEmployee", allEmployee)
  function removeDuplicatesByID(array) {
    const seen = new Set();
    return array.filter((item) => {
      if (seen.has(item.ID)) {
        return false;
      }
      seen.add(item.ID);
      return true;
    });
  }
  const filterData = removeDuplicatesByID(allEmployee)

  const fetchLeaveSummary = async (empId, fromDate, toDate) => {
    setLoading(true);
    try {
      const formattedFrom = moment(fromDate).format('DD-MM-YYYY');
      const formattedTo = moment(toDate).format('DD-MM-YYYY');
      // console.log(formattedFrom)
      // console.log(formattedTo)
      const res = await getRequest(
        `getLeavesummary/${empId}?fromdate=${formattedFrom}&todate=${formattedTo}`
      );
      // console.log("response:", res);
      setLeaveData(res?.data)
      // setLoading(false);
      setToDate(null)
      setFromDate(null)
      setEmployeeId(null)
    } catch (err) {
      console.error(err);
      message.error('Failed to load leave summary');
      setLeaveData([]);
    } finally {
      setLoading(false);
    }
  };

  const handleSubmit = () => {
    if (!employeeId || fromDate == null || toDate == null) {
      return message.warning('Please select both employee and date ');
    }
    // console.log(fromDate, toDate)
    fetchLeaveSummary(employeeId, fromDate, toDate);
  };
  // console.log("leaveData", leaveData)
  return (
    <div className="bg-white rounded-2xl shadow p-4   sm:p-6 w-full">
      <div className="flex flex-col lg:flex-row gap-3 sm:gap-4 lg:gap-6 shadow-lg p-8 rounded-sm items-start lg:items-center justify-start w-full">
        <div className="w-full lg:w-[400px]">
          <label className="block  font-semibold">
            Employee Name <span className="text-red-500">*</span>
          </label>
          <SelectEmployee
            employeeList={filterData}
            onChange={(value) => setEmployeeId(value)}
            selectedEmployee={employeeId}
            customStyle="w-full"
            allLabel={{}}
          />
        </div>

        <div className="flex justify-start flex-wrap  items-center gap-3 flex-1 ">

          <span className='flex-1'>
            <label className="block font-semibold">
              From Date <span className="text-red-500">*</span>
            </label>
            <DatePickerComponent
              onChange={(date, dateString) => setFromDate(dateString)}
              date={fromDate}
              placeholder="From Date"
              customStyle="h-10 w-full "
            />
          </span>
          <span className='flex-1'>

            <label className="block  font-semibold">
              To Date <span className="text-red-500">*</span>
            </label>
            <DatePickerComponent
              onChange={(date, dateString) => setToDate(dateString)}
              date={toDate}
              placeholder="To Date"
              customStyle="h-10 w-full "
            />
          </span>

          <span className=''>
            <Button type="primary" className=" text-lg mt-6 font-bold text-gray-100 py-5 px-12  " onClick={handleSubmit}>
              Submit
            </Button>
          </span>
        </div>


      </div>

      {loading ? (
        <div className="mt-6 flex justify-center">
          <Spin tip="Loading leave summary..." />
        </div>
      ) :
        leaveData.length === 0 ? (
          <div className="mt-10 flex flex-col items-center justify-center
                  border border-dashed border-gray-300 dark:border-gray-700
                  rounded-xl p-10 text-center bg-gray-50 dark:bg-gray-900">

            <div className="w-14 h-14 flex items-center justify-center
                    rounded-full bg-blue-100 dark:bg-blue-900 mb-4">
              <svg
                className="w-7 h-7 text-blue-600 dark:text-blue-300"
                fill="none"
                stroke="currentColor"
                strokeWidth="2"
                viewBox="0 0 24 24"
              >
                <path strokeLinecap="round" strokeLinejoin="round"
                  d="M8 7V3m8 4V3m-9 8h10M5 21h14a2 2 0 002-2V7a2 2 0 00-2-2H5a2 2 0 00-2 2v12a2 2 0 002 2z"
                />
              </svg>
            </div>

            <h3 className="text-lg font-semibold text-gray-700 dark:text-gray-200">
              No Leave Records
            </h3>

            <p className="text-sm text-gray-500 dark:text-gray-400 mt-1 max-w-sm">
              Please select an employee and date range, then click search to view leave details.
            </p>
          </div>
        ) :
          (
            <div className="mt-6">
              <LeaveTable leaveData={leaveData} startDate={fromDate} endDate={toDate} />
            </div>
          )}
    </div>
  );
};

export default LeaveSummary;
